<template>
    <div class="whey">
        <div class="wheys">
            404 找不到
        </div>
        
    </div>
  </template>
  <script>
  
  export default {
    data() {
      return {
      };
    },
    created() {
    },
    methods: {
    }
  };
  </script>
  
  <style lang="less" scoped>
  .whey{
    width: 100vw;
    height: 100vh;
   display: flex;
   justify-content: center;
   align-items: center;
  }
  .wheys{
        font-size: 0.8rem;
    }
  </style>